import { Component, OnInit, OnDestroy, AfterViewInit, QueryList, ViewChild, ViewChildren, ChangeDetectorRef } from '@angular/core';
import { AuctionFilter } from '../../models/auction-filter';
import { HttpClient } from '@angular/common/http';
import { BusAuctionFilterService } from '../../services/bus-auction-filter.service';
import { DataTableDirective } from 'angular-datatables';
import { skip } from "rxjs/operators";

import { environment } from '../../../../../environments/environment';
import { LoggingService } from '../../../../services/logging.service';

class DataTablesResponse {
  data: any[];
  draw: number;
  recordsFiltered: number;
  recordsTotal: number;
}

const apiServer = environment.apiServer;
declare var $: any;

@Component({
  selector: 'app-home-main-modal-region',
  templateUrl: './home-main-modal-region.component.html',
  styleUrls: ['./home-main-modal-region.component.sass']
})


export class HomeMainModalRegionComponent implements OnInit, OnDestroy, AfterViewInit {

  private subs: any[] = [];
  private opened = false;

  @ViewChild(DataTableDirective) datatableElement: DataTableDirective;
  @ViewChildren('regionCheckInput') nameInputModel: QueryList<any>;

  dt: DataTables.Api;

  modelAuctionFilter: AuctionFilter = new AuctionFilter();

  dtOptionsRegion: DataTables.Settings = {};
  dataSetRegions: any;
  checkedRegion: string[];

  constructor(private http: HttpClient, private bus: BusAuctionFilterService, private loggingService: LoggingService, private cd: ChangeDetectorRef) {
    this.checkedRegion = [];
  }

  ngOnInit() {
    this.subs.push(
      this.bus.currentClearModalFilter$
        .pipe(skip(1))  // При инициализации фильтр уже очищен
        .subscribe(key => {
          if (key === 'region' || key === "all") {
            this.nameInputModel.forEach(function (item) {
              item.nativeElement.checked = false;
            });
            this.checkedRegion = [];

            if (key !== "all") {
              this.onAuctionFilter();
            }
          }
        })
    );

    const that = this;
    
    $('#modalRegions').off('shown.bs.modal').on('shown.bs.modal', function () {
      if (!that.opened) {
        that.opened = true;
        that.dt.ajax.reload();
      }
    });

    this.dtOptionsRegion = {
      pagingType: 'full_numbers',
      pageLength: 250,
      serverSide: true,
      processing: true,
      autoWidth: false,
      order: [1],
      deferLoading: 0,
      dom: 'ti',
      language: {
        emptyTable: 'Нет данных',
        info: 'Отображено с _START_ по _END_ из _TOTAL_ записей',
        infoEmpty: 'Отображено с 0 по 0 из 0 записей',
        infoFiltered: '(отфильтровано из _MAX_ записей)',
        infoPostFix: '',
        thousands: ',',
        lengthMenu: 'Показывать по _MENU_ записей',
        loadingRecords: 'Загрузка ...',
        processing: 'Обработка ...',
        search: 'Поиск:',
        zeroRecords: 'Нет совпадающих значений для поиска',
        paginate: {
          first: 'Первая',
          last: 'Последняя',
          next: 'След.',
          previous: 'Пред.'
        },
        aria: {
          sortAscending: ': activate to sort column ascending',
          sortDescending: ': activate to sort column descending'
        }
      },
      ajax: (dataTablesParameters: any, callback) => {

        that.http.post<DataTablesResponse>(`${apiServer}/region`, dataTablesParameters, {})
          .subscribe(resp => {
            that.dataSetRegions = resp.data;
            callback({
              recordsTotal: resp.recordsTotal,
              recordsFiltered: resp.recordsFiltered,
              data: []
            });
            that.cd.detectChanges();
          });
      },
      columns: [

        { orderable: false },
        { data: 'SubjectID', name: 'SubjectID', orderable: false },
        { data: 'FO', name: 'FO', orderable: false }

      ]
    };
  }

  ngOnDestroy() {
    this.subs.forEach(sub => sub.unsubscribe());
  }

  onSelectedRow(event, value) {
    const _xid = this.loggingService.generateUUID();
    
    try {
      this.loggingService.logStart(_xid, 'App.Components.HomeMainModalRegionComponent.onSelectedRow', null, 'Row selection started');
      
      if (event.target.checked) {
        this.checkedRegion.push(value);
      } else {
        for (let i = 0; i < this.checkedRegion.length; i++) {
          if (this.checkedRegion[i] === value) {
            this.checkedRegion.splice(i, 1);
          }
        }
      }
      
      this.loggingService.logFinish(_xid, 'App.Components.HomeMainModalRegionComponent.onSelectedRow', null, 'Row selection completed');
    } catch (_error) {
      this.loggingService.logError(_xid, 'App.Components.HomeMainModalRegionComponent.onSelectedRow', _error, null, 'Row selection failed');
      throw _error;
    }
  }

  onSelectingRows(event) {
    const _xid = this.loggingService.generateUUID();
    
    try {
      this.loggingService.logStart(_xid, 'App.Components.HomeMainModalRegionComponent.onSelectingRows', null, 'Selecting all rows started');
      
      const that = this;

      this.nameInputModel.forEach(function (item) {
        item.nativeElement.checked = event.target.checked;

        if (event.target.checked) {
          that.checkedRegion.push(item.nativeElement.value);
        } else {
          for (let i = 0; i < that.checkedRegion.length; i++) {
            if (that.checkedRegion[i] === item.nativeElement.value) {
              that.checkedRegion.splice(i, 1);
            }
          }
        }
      });
      
      this.loggingService.logFinish(_xid, 'App.Components.HomeMainModalRegionComponent.onSelectingRows', null, 'Selecting all rows completed');
    } catch (_error) {
      this.loggingService.logError(_xid, 'App.Components.HomeMainModalRegionComponent.onSelectingRows', _error, null, 'Selecting all rows failed');
      throw _error;
    }
  }

  onAuctionFilter() {
    const _xid = this.loggingService.generateUUID();
    
    try {
      this.loggingService.logStart(_xid, 'App.Components.HomeMainModalRegionComponent.onAuctionFilter', null, 'Auction filter started');
      
      this.modelAuctionFilter.region = this.checkedRegion.join(",");
      this.bus.changeFilter(this.modelAuctionFilter);
      
      this.loggingService.logFinish(_xid, 'App.Components.HomeMainModalRegionComponent.onAuctionFilter', null, 'Auction filter completed');
    } catch (_error) {
      this.loggingService.logError(_xid, 'App.Components.HomeMainModalRegionComponent.onAuctionFilter', _error, null, 'Auction filter failed');
      throw _error;
    }
  }

  ngAfterViewInit(): void {
    this.datatableElement.dtInstance.then((dtInstance: DataTables.Api) => {
      this.dt = dtInstance;
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/home/components/home-main-modal-region/home-main-modal-region.component.ts